import React, { useState } from 'react';
import { Box, Container, useTheme, useMediaQuery, Typography } from '@mui/material';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import FailedTransactionsTable from '../components/FailedTransactionsTable';
import { Icon } from '@iconify/react';
interface FailedTransactionsProps {
  onLogout: () => void;
}
export const FailedTransactions: React.FC<FailedTransactionsProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-1561">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-1562" />

      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="failed-transactions" data-id="element-1563" />

      <Box component="main" sx={{
      flexGrow: 1,
      p: {
        xs: 2,
        md: 3
      },
      width: {
        sm: `calc(100% - 240px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-1564">
        <Container maxWidth="xl" disableGutters={isMobile} data-id="element-1565">
          <Box sx={{
          mb: 3
        }} data-id="element-1566">
            <Box sx={{
            width: 42,
            height: 42,
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#0052CC'
          }} data-id="element-1567">
              <Icon icon="lucide:alert-circle" width={22} height={22} color="white" data-id="element-1568" />
            </Box>
            <Typography variant="h5" fontWeight={700} color="#1F2937" data-id="element-1569">
              Failed Transactions
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary" data-id="element-1570">
            Review and manage transactions that failed during processing.
          </Typography>
        </Container>
      </Box>
    </Box>;
};
export default FailedTransactions;